<template>
    <v-autocomplete
        :loading="loading"
        :items="items"
        :search-input.sync="search"
        v-model="model"
        :item-value="datamodel.value"
        :item-text="datamodel.text"
        return-object
        flat
        hide-no-data
        clearable
        :label="label"
        :rules="rules"
        @input="changed"
        v-bind="$attrs"
    >
        <template v-slot:item="{ item }" v-if="hasSlotData">
            <slot name="item" v-bind:item="item"></slot>
        </template>
    </v-autocomplete>
</template>

<script>
import { debounce } from 'lodash';

export default {
    name: 'v-suggest',
    props: {
        label: {
            type: String
        },
        value: {
            type: Object
        },
        endpoint: {
            type: Function
        },
        display: {
            type: Function
        },
        rules: {
            type: Array
        },
        datamodel: {
            type: Object,
            default: () => { return {
                text: 'text',
                value: 'value'
            }}
        },
        mapResults: {
            type: Function,
            default: results => results.suggestions
        },
    },
    data() {
        return {
            loading: false,
            items: [],
            search: '',
            model: ''
        }
    },
    computed: {
        hasSlotData() {
            return this.$scopedSlots && !!this.$scopedSlots.items;
        }
    },
    watch: {
      search(val) {
          this.suggest(val);
      },
      value(val) {
        !this.model && this.init();
      }
    },
    methods: {
        suggestImpl(val) {
            console.log('SuggestImpl('+val+')', (
                val && val !== this.model[this.datamodel.text]
            ));
            val && val !== this.model[this.datamodel.text] && this.querySelections(val);
            if (typeof this.model === 'undefined') {// Fix suggestment break when clear-btn sets model=undefined
                this.model = '';
            }
        },
        querySelections(q) {
            console.log('doSuggest ' + q);
            this.loading = true;
            this.endpoint({q}).then((result) => {
                this.items = this.mapResults(result.body);
            }).catch((err) => {
                console.log('Error suggesting ', err);
            }).finally(() => {
                this.loading = false;
            });
        },
        init() {
            // console.log('suggester init');
            // do we have display function
            if (this.display && !!this.value && !!this.value[this.datamodel.value]) {
                this.display({ id : this.value[this.datamodel.value] }).then((res) => {
                    let s = res.body;
                    this.items = new Array();
                    this.items.push(s);
                    this.model = s;
                    this.search = s[this.datamodel.text];
                }).catch((err) => {
                    let s = {};
                    s[this.datamodel.value] = this.value[this.datamodel.value];
                    s[this.datamodel.text]  = this.value[this.datamodel.text];
                    this.items = new Array();
                    this.items.push(s);
                    this.model = s;
                    this.search = s[this.datamodel.text];
                });
            } else {
                // default init
                let s = {
                    [this.datamodel.value] : this.value ? this.value[this.datamodel.value] : null,
                    [this.datamodel.text]  : this.value ? this.value[this.datamodel.text] : ''
                };
                this.items = this.value ? [s] : [];
                this.model = s;
                this.search = s[this.datamodel.text];
            }
        },
        changed() {
            // console.log('changed');
            this.$emit('input', this.model || null);
        }
    },

    created() {
        this.suggest = debounce(this.suggestImpl, 400);
    }
}
</script>